import { redirect, RouteObject } from 'react-router'

import { PLATFORM } from '@/constants/platform'
import { STREAMING_MENU_ICONS } from '@/router/icons'
import OperatorsView from '@/views/Operators'
import OperatorView from '@/views/Operators/Operator'
import LicensesView from '@/views/Operators/Operator/Licenses'

export const operatorRoutes: RouteObject[] = [
  {
    path: 'operators',
    label: 'Operators',
    platforms: [PLATFORM.DGE],
    icon: STREAMING_MENU_ICONS.OPERATORS,
    children: [
      {
        index: true,
        element: <OperatorsView />,
        platforms: [PLATFORM.DGE]
      },
      {
        path: ':operatorId/*',
        element: <OperatorView />,
        children: [
          {
            index: true,
            loader: () => redirect('licenses'),
            platforms: [PLATFORM.DGE]
          },
          {
            path: 'licenses',
            element: <LicensesView />,
            platforms: [PLATFORM.DGE]
          }
        ]
      }
    ]
  }
]
